module.exports = __webpack_public_path__ + "static/media/corporateStep3.de4491a0.svg";